var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTsifrovye = function SvgTsifrovye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#1790FF",
    fillOpacity: 0.1,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1790FF",
    d: "M20 28.333a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 1 1 0 16.666Zm-1.908-1.944a14.918 14.918 0 0 1-1.403-5.556h-3.304a6.672 6.672 0 0 0 4.707 5.556Zm.266-5.556A13.262 13.262 0 0 0 20 26.46a13.254 13.254 0 0 0 1.642-5.627h-3.284Zm8.257 0h-3.304a14.918 14.918 0 0 1-1.403 5.556 6.673 6.673 0 0 0 4.707-5.556Zm-13.23-1.666h3.304c.104-1.925.58-3.812 1.403-5.556a6.673 6.673 0 0 0-4.707 5.556Zm4.974 0h3.282A13.255 13.255 0 0 0 20 13.54a13.254 13.254 0 0 0-1.642 5.627h.001Zm3.55-5.556a14.919 14.919 0 0 1 1.402 5.556h3.304a6.674 6.674 0 0 0-4.707-5.556Z"
  })));
};
export default SvgTsifrovye;